export default __webpack_public_path__ + "alberta-drug-distribution.8fde96dbb427d332c683.svg";